"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Bridge = void 0;

var _Driver = require("./core/Driver"),
    _getEnvironment = require("./core/getEnvironment"),
    _Plugin = require("./core/Plugin"),
    _Stream = require("./core/Stream");

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var Bridge = /*#__PURE__*/function () {
  function Bridge() {
    _classCallCheck(this, Bridge);

    _defineProperty(this, "environment", (0, _getEnvironment.getEnvironment)()), _defineProperty(this, "driver", void 0), _defineProperty(this, "plugin", void 0), _defineProperty(this, "stream", void 0), _defineProperty(this, "analytics", void 0), _defineProperty(this, "image", void 0), _defineProperty(this, "info", void 0), _defineProperty(this, "login", void 0), _defineProperty(this, "payment", void 0), _defineProperty(this, "region", void 0), _defineProperty(this, "router", void 0), _defineProperty(this, "share", void 0), _defineProperty(this, "storage", void 0), _defineProperty(this, "toast", void 0), this.driver = new _Driver.Driver().install(), this.stream = new _Stream.Stream(this.driver), this.plugin = new _Plugin.Plugin(this.driver, this.stream);
  }

  _createClass(Bridge, [{
    key: "addPlugin",
    value: function addPlugin(a) {
      var b = new a(this.driver, this.plugin, this.stream);
      return this[b.namespace] = b, this;
    }
  }]);

  return Bridge;
}();

exports.Bridge = Bridge;